import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { paths } from '@app/constants';
import { Role } from '@data/sdk/match';
import { useAppUserStore } from '@data/storage';
import { AntdSelect } from '@ui/components';

export const RolesSwitcher = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, setUser } = useAppUserStore();

  const options = useMemo(
    () => user?.roles.map((el) => ({ label: t(`user_role.${el}`), value: el })),
    [user],
  );

  const switchBetweenRoles = (role: Role) => {
    if (user) {
      setUser({ ...user, currentRole: role });
      navigate(`/${paths.app}`, { replace: true });
    }
  };

  return user && user?.roles.length > 1 ? (
    <AntdSelect
      options={options}
      className="w-36"
      value={user.currentRole}
      onChange={switchBetweenRoles}
    />
  ) : null;
};
